import { BrowserRouter, Route } from 'react-router-dom';
import React from 'react';
import { hydrate } from 'react-dom';
import { ApolloProvider } from '@apollo/react-common';
import * as Sentry from '@sentry/browser';
import createApolloClient from './services/apollo';
import App from './App';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://7f20775b3a8449aaa8c8dc306426bbe6@sentry.kiper.com.br/14',
  });
}

const apolloClient = createApolloClient();

hydrate(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter>
      <App />
      <Route
        render={() => {
          if (typeof window !== 'undefined') {
            window.dataLayer.push(['send', 'pageview']);
          }
          return null;
        }}
      />
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept();
}
